export class Collection<T> {
	public items: T[];
	public totalItems: number;

	constructor(params?: CollectionParams<T>) {
		if (params) {
			this.items = params.items;
			this.totalItems = params.totalItems ?? this.items.length;
		}
	}
}

interface CollectionParams<T> {
	items: T[];
	totalItems?: number;
}
